import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { get } from 'lodash'
import BillingAddBankAccountForm from './BillingAddBankAccountForm'
import { setupBankAccount, updateBankAccount } from 'features/Billing/Billing.actions'

const formName = 'addBankAccount'

const stateToProps = (
  { form, billing: { setupIntent, setupIntentLoading, updateLoading } },
  { billingAccount }
) => ({
  form: formName,
  formData: get(form, `${formName}.values`, {}),
  initialValues: {
    ban: billingAccount.ban,
    name: billingAccount.customer,
    email: billingAccount.invoiceDelivery,
  },
  clientSecret: setupIntent?.client_secret,
  loading: setupIntentLoading || updateLoading,
})

const dispatchToProps = {
  setupBankAccount,
  updateBankAccount,
}

export default connect(stateToProps, dispatchToProps)(reduxForm({})(BillingAddBankAccountForm))



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddBankAccountForm/BillingAddBankAccountForm.container.js